import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BrowserService } from '@app/services/browser/browser.service';
import { UtilsService } from '@app/services/util/util-service';
import { environment } from '@env/environment';
import { ConfigurationService } from '@app/services/configuration/configuration.service';
import { LocalizationService } from '../internationalization/localization.service';
import { Language } from '@app/models/language.model';

@Component({
    selector: 'app-welcome',
    templateUrl: './welcome.component.html',
    styleUrls: ['./welcome.component.scss'],
    standalone: false
})
export class WelcomeComponent implements OnInit {
  public siteId: string | undefined;
  creatingATechnicianUserProfileGuide = ``;
  userManagementGuide = ``;
  subcontractorVisitsToCityPartnersGuide = ``;
  language: string = environment.defaultLang;
  languages: Language[] = [];
  isMutliLanguageEnable: boolean = false;

  constructor(private _utilsService: UtilsService,
    private _browserService: BrowserService,
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _configurationService: ConfigurationService,
    private _localizationService: LocalizationService
  ) { this.siteId = this._activatedRoute.snapshot.paramMap.get('siteId')?.toLocaleLowerCase(); }
  
  ngOnInit(): void {
    this._configurationService.getTechnicianUserProfileGuide().then(t => {
      this.creatingATechnicianUserProfileGuide = t;
    });
    this._configurationService.getUserManagementGuide().then(t => {
      this.userManagementGuide = t;
    });
    this._configurationService.getSubcontractorVisitsToColesDCsGuide().then(t => {
      this.subcontractorVisitsToCityPartnersGuide = t;
    });

    var isWeb = this.isWebBrowser();
    if(!isWeb){
     this.proceedToLoginUserInBrowser();
    }

    this.init();
  }

  async init(){
    this.language = await this._localizationService.get() ?? environment.defaultLang;
    
    this.isMutliLanguageEnable = await this._configurationService.getIsMultiLanguageEnable();
    if(this.isMutliLanguageEnable){
      this._localizationService.getLanguages().subscribe({
        next: async (langs) => {
          this.languages = [...langs];
        }
      });
    }
  }


  proceedToLoginUserInBrowser() {
    this._router.navigate([`login/user/${this.siteId}`]);
  }

  isWebBrowser(): boolean {
    return this._utilsService.isWebBrowser();
  }

  async installApple() {
    this._browserService.openUrl(await this._configurationService.getApplePlayURL());
  }

  async installGoogle() {
    this._browserService.openUrl(await this._configurationService.getGooglePlayUrl());
  }

  onLangSelect(lang: string): void {
    this._localizationService.set(lang).then(() => {
      this.language = lang;
      this._localizationService.useLanguage(lang);
    });
    const locale = this.languages.find(l => l.code === lang)?.azureLocales;
    if (locale) {
      this._localizationService.setAzureLocale(locale);
    }
  }

}
